<div
  class="relative w-72 aspect-[305/200] flex items-center justify-center shadow-lg"
>
    <!-- Fundo da carta -->
    <img
      src="assets/card/CARD.svg"
      class="absolute inset-0 w-full h-full object-contain"
    />

    <!-- Logo centralizada menor -->
    <img src="assets/card/LogoCBDE.png" class="relative h-1/6 object-contain" />

</div>
